document.addEventListener('DOMContentLoaded', function () {
    new Vue({
        el: '#instagram-slider',
        data() {
            return {
                images: [],
                splideOptions: {
                    type: 'loop',
                    perPage: 5,
                    perMove: 1,
                    autoplay: false,
                    gap: '1rem',
                    padding: { right: '8%', left: "8%" },
                    autoHeight: true,
                    pagination: false,
                    arrows: false,
                    breakpoints: {
                        2000: {
                            perPage: 4,
                        },
                        1200: {
                            perPage: 3,
                        },
                        992: {
                            perPage: 2,
                        },
                        760: {
                            perPage: 1,
                        },
                    }
                },
            };
        },
        mounted() {
            fetch('/api/instagram/get-images?take=10')
                .then(response => response.json())
                .then(data => {
                    this.images = data;
                    this.$nextTick(() => {
                        new Splide(this.$refs.splide, this.splideOptions).mount();
                    });
                })
                .catch(error => {
                    console.error('Error fetching images:', error);
                });
        },
    });
});
